import { memo } from 'react';
import { IconProps } from './iconType';

export const EntrySiteIcon = memo(({ size, color, color2 }: IconProps) => {
  return (
    // export된 svg가 있다면 => 코드창에 열어서 있는 코드 아래 형식처럼 수정하기
    // 디자인 파일에서 svg가 있다면 => svg 코드 복사해서 아래 형식처럼 수정하기
    // xmlns 속성은 제거
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <path
        d="M13.5 10.5H21.5V21.5H2.5V10.3057L8.5 7.75488V9.73828L9.18555 9.46387L13.5 7.7373V10.5ZM6.5 18.5H9.5V13.5H6.5V18.5ZM10.5 18.5H13.5V13.5H10.5V18.5ZM14.5 18.5H17.5V13.5H14.5V18.5ZM20.5576 2.5L21.2344 8H17.7451L18.4639 2.5H20.5576Z"
        fill={color}
        stroke={color2}
      />
    </svg>
  );
});

EntrySiteIcon.displayName = 'EntrySiteIcon';
